// extracted by mini-css-extract-plugin
export default {"serviceProviderRow":"User_serviceProviderRow__mHgWB","serviceProviderRow__link":"User_serviceProviderRow__link__hfJVq"};